<template lang="pug">
  v-card.px-4(flat style="border:1px solid var(--v-basic400);")
    template(v-if="restrictedDatesHeader")
      .s1.mt-4 {{ $t('restricted_dates') }}
      .c1.basic600--text {{ $t('restricted_dates_text') }}
    .dates.d-flex.mt-4(v-for="(date, index) in settings.restricted_dates" :key="date + index")
      v-dialog(v-model="settings.restricted_dates[index].show" max-width="320px")
        template(v-slot:activator='{ on }')
          v-text-field.mt-2(v-model="settings.restricted_dates[index].display" placeholder="Select date" outlined background-color="basic200" height="40" dense :rules="rules.not_empty" readonly v-on='on' hide-details)
            template(v-slot:append)
              eva-icon(name="calendar-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic600")
        v-date-picker.pt-6(v-model="settings.restricted_dates[index].value" color="textColorAccent" @change="saveDate(date, index)" no-title)
      eva-icon.mt-4.ml-4(name="close-circle-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="24" height="24" @click="settings.restricted_dates.splice(index, 1)")
    v-btn.my-4.px-0(color="textColorAccent" small text @click="clickAddDate")
      eva-icon.mr-1(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="16" height="16" style="margin-top: 3px")
      span.button-Aa-small.textColorAccent--text {{ $t('add_date') }}

</template>

<script>
export default {
  name: 'RestrictedDates',
  components: { },
  props: ['parentSettings', 'restrictedDatesHeader'],
  data: () => ({
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
    }
  }),
  computed: {
    settings: {
      get () {
        return this.parentSettings
      },
      set (newValue) {
        this.$emit('update:parentSettings', newValue)
      }
    }
  },
  watch: {

  },
  mounted () {

  },
  methods: {
    saveDate (data, index) {
      this.settings.restricted_dates[index].date = data.value
      this.settings.restricted_dates[index].display = this.formatDate(data.value)
      this.settings.restricted_dates[index].show = false
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clickAddDate () {
      const data = { date: null, show: false, value: null, display: '' }
      this.settings.restricted_dates.push(data)
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "add_date": "Add date",
    "restricted_dates": "Restricted dates",
    "restricted_dates_text": "Prevent customers from selecting pickup and delivery on specific dates of the year."
  },
  "id": {
    "add_date": "Tambah tanggal",
    "restricted_dates": "Batasan tanggal",
    "restricted_dates_text": "Pelanggan tidak bisa memilih pengambilan dan pengiriman pada tanggal tertentu dalam setahun"
  }
}
</i18n>
